import { default as BrowserHelper } from "./vue/helper/browser-helper";
var SliderHelper = /** @class */ (function () {
    function SliderHelper() {
    }
    SliderHelper.insertLazyImages = function (element) {
        if (element) {
            var sourceTags = element.querySelectorAll('source[data-srcset]');
            var imgTag = element.querySelector('img[data-src]');
            for (var j = 0; j < sourceTags.length; j++) {
                var sourceTag = sourceTags[j];
                SliderHelper.copyDataAttribute(sourceTag, 'data-srcset');
            }
            if (imgTag) {
                SliderHelper.copyDataAttribute(imgTag, 'data-src');
                SliderHelper.copyDataAttribute(imgTag, 'data-srcset');
            }
        }
    };
    SliderHelper.copyDataAttribute = function (element, dataAttribute) {
        if (element && dataAttribute) {
            var dataValue = element.getAttribute(dataAttribute);
            var attribute = dataAttribute.replace('data-', '');
            var attributeValue = element.getAttribute(attribute);
            if (dataValue && !attributeValue) {
                element.setAttribute(attribute, dataValue);
                element.removeAttribute(dataAttribute);
            }
        }
    };
    SliderHelper.insertLazyImagesForSlickSlider = function (element, slick) {
        if (element && slick) {
            var sourceTags = element.querySelectorAll('source[data-srcset]');
            var imgTag = element.querySelector('img[data-src]');
            for (var j = 0; j < sourceTags.length; j++) {
                var sourceTag = sourceTags[j];
                SliderHelper.copyDataAttributeForSlickSlider(sourceTag, 'data-srcset', slick);
            }
            if (imgTag) {
                SliderHelper.copyDataAttributeForSlickSlider(imgTag, 'data-src', slick);
                SliderHelper.copyDataAttributeForSlickSlider(imgTag, 'data-srcset', slick);
            }
        }
    };
    SliderHelper.copyDataAttributeForSlickSlider = function (element, dataAttribute, slick) {
        if (element && dataAttribute && slick) {
            var dataValue = element.getAttribute(dataAttribute);
            var attribute = dataAttribute.replace('data-', '');
            var attributeValue = element.getAttribute(attribute);
            if (dataValue && !attributeValue) {
                var slickClone = slick.$slider[0].querySelector('.slick-cloned [' + dataAttribute + '="' + dataValue + '"]');
                element.setAttribute(attribute, dataValue);
                element.removeAttribute(dataAttribute);
                if (slickClone) {
                    slickClone.setAttribute(attribute, dataValue);
                    slickClone.removeAttribute(dataAttribute);
                }
            }
        }
    };
    SliderHelper.isSliderEnabled = function () {
        return !BrowserHelper.isInternetExplorer();
    };
    SliderHelper.isSlickEnabled = function () {
        return !BrowserHelper.isInternetExplorer();
    };
    return SliderHelper;
}());
export default SliderHelper;
